import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIcEdit({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.82 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.986 12.622 4.997-5c-1.44-1.379-3.297-2.193-5.285-2.203-.077 0-.153.002-.23.005a7.142 7.142 0 0 0-.23-.005c-3.6.018-6.77 2.673-7.813 6.545a.673.673 0 0 0 .085.54.526.526 0 0 0 .436.246H10.716c.037-.044.077-.086.119-.128Zm6.417-3.238-3.364 3.366-1.46 1.462a.25.25 0 0 0 0 .354l2.14 2.143a.25.25 0 0 0 .354 0l5.709-5.713a.25.25 0 0 0 0-.354L18.489 13a.257.257 0 0 0-.354 0l-.884.885Zm-5.358 5.723a.25.25 0 0 0-.414.1l-1.07 3.214a.25.25 0 0 0 .315.317l3.211-1.071a.25.25 0 0 0 .1-.415l-2.142-2.145Zm7.492-7.857a1.806 1.806 0 0 1 2.495 0c.687.69.687 1.805 0 2.495l-.357.359a.25.25 0 0 1-.353 0l-2.14-2.143a.25.25 0 0 1 0-.354l.355-.357Z"
                fill="currentColor"
            />
        </svg>
    )
}
SvgIcEdit.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIcEdit
